import { defineStore } from 'pinia';
import { ref } from 'vue';

export const useThemeStore = defineStore('theme', () => {
  const currentTheme = ref<'SILog' | 'TILog' | 'Fleetskill'>('SILog');

  function setTheme(theme: 'SILog' | 'TILog' | 'Fleetskill') {
    currentTheme.value = theme;
  }

  return {
    currentTheme,
    setTheme,
  };
});
